import {Controller} from "stimulus"
/**
 * Form bone de recharge
 */
export default class extends Controller {

    static targets = [
        "image"
    ]

    initialize() {

        const nav = document.querySelector('.nav');

        setTimeout(()=> {
            this.imageTarget.classList.add('is-active')
        }, 1700)

        this.imageTarget.addEventListener('transitionend', ()=>{
            nav.classList.remove('is-active')
        })

    }
}